import React, { useContext, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive'

import * as ImageFile from '../../../Global/ImageFile';
import Toggle from '../../../Global/Toggle';
import Markup from '../../../../markup';
import CheckBox from '../../../Global/CheckBox';
import TooltipHover from '../../../Global/TooltipHover';
import {useHistory} from 'react-router-dom';
import { device } from '../../../../const/device';
import BuilderContext from '../../../../builder/hooks/context';
import ModalWrapper from "../../../Global/ModalWrapper";
import LogosFlag from "./LogosFlag";
import {sides} from "../../../../const/sides";
import { trackSubStage, trackBeforeUnload } from '../../../../utils/Analytics';

const logoSponsorSides = {
  'front': 'Front side',
  'back': 'Back side',
  'left': 'Left sleeve',
  'right': 'Right sleeve',
};

function LogosSponsor() {
  const { builder } = useContext(BuilderContext);
  const isMobile = useMediaQuery({ query: `(${device.mobileL})` })
  const isTablet = useMediaQuery({ query: `(${device.tablet})` });
  const [side, setSide] = useState(() => {
    if (isMobile) return null;
    return builder?.manifest?.productId === '1207903' ? 'left' : 'front';
  });
  const [modalIsOpen, changeModalState] = useState<boolean>(false);
  const history = useHistory();
  const [needsUpdate, setNeedsUpdate] = useState(false);

  useEffect(() => {
    trackSubStage('Logos', 'Images');
    trackBeforeUnload('Images');
  }, []);

  useEffect(() => {
    builder?.setCamera("front");
  },[])

  useEffect(() => {
    modalIsOpen && !isTablet && changeModalState(false);
    isTablet && history.location.pathname.includes('/logos/1/flags') && changeModalState(true);
  },[modalIsOpen, isTablet])

  const getSleeveSide = (side) => {
    if([sides.LEFT, sides.RIGHT].includes(side) && !builder?.options?.sleeve) return `${side}_long`;
    return side;
  }

  const images = builder.imagesData.sponsorImages[getSleeveSide(side)]
  const maxImages = (side === 'left' || side === 'right') ? 5 : 10;

  const currentFlag = builder.imagesData.sponsorFlag[side];

  const setSponsorLogoSide = (side) => {
    if (!builder?.animationState) {
      builder?.setAnimationState(true);
  
      if (builder?.manifest?.productId === '1207903') {
        if (side === 'left' || side === 'right') {
          builder?.setCamera('front');
          setSide(side);
        } else {
          return;
        }
      } else {
        builder?.setCamera(side);
        setSide(side);
      }
    }
  };

  const onFlagSelect = () => {
    history.push(`/logos/1/flags/${side}`)
    isTablet  && changeModalState(true);
  }

  const modalOnToogle = (state) => {
    !state && history.goBack();
    changeModalState(state);
  }

  const MobileHeader = () => (
    <>
      <Markup.Screen.Logos.MobileHeader>
        <Markup.Global.Button.ButtonIconClose tabletOnly onClick={() => setSide(null)} />

        <Markup.Screen.Logos.MobileTitleContainer>
          {sides[side]}
        </Markup.Screen.Logos.MobileTitleContainer>

        <Markup.Global.Button.ButtonIconSubmit onClick={() => setSide(null)} />
      </Markup.Screen.Logos.MobileHeader>
    </>
  );

  const handleAddAnotherLogo = () => {
    const currentImages = builder.imagesData.sponsorImages[getSleeveSide(side)];
  
    if (currentImages.length < maxImages) {
      currentImages.push({});
      builder.imagesData.sponsorImages[getSleeveSide(side)] = currentImages;
      setNeedsUpdate(!needsUpdate);
    }
  };

  const CheckBoxHelpText = <Markup.Screen.Color.HelpTextContainer padding={8}>Please select flag</Markup.Screen.Color.HelpTextContainer>

  return (
    <>
      <Markup.Screen.Logos.SponsorWrapper>
        {isMobile && side && <MobileHeader />}
        {(!isMobile || (isMobile && !side)) && <Toggle items={builder.logoTabs.sponsorLogo} titles={logoSponsorSides} active={side} setActive={item => setSponsorLogoSide(item)} />}
        {side &&
          <>
            <Markup.Global.Text.P weight='normal'>Click and drag files to change the order of each item.</Markup.Global.Text.P>
            <ImageFile.BaseContainer
              minimal={currentFlag}
              hasPreview={true}
              side={side}
              setImage={(image, index, public_url) =>
                builder.imagesData.updateSponsorImage(side, index, image, public_url)
              }
              images={images}
              isSleeves={builder?.manifest?.productId === '1207903'}
            />
            {images.length < maxImages && <Markup.Global.Button.TextButton weight='bold' onClick={handleAddAnotherLogo}>+ Add another logo</Markup.Global.Button.TextButton>}
            
          </>
        }

        {(currentFlag && Object.keys(builder.modelData.flags).length > 0) &&
          <Markup.Screen.Logos.FlagWrapper>
            <Markup.Screen.Logos.FlagItem flag={currentFlag.id} onClick={onFlagSelect} />
           
           {currentFlag.id && <CheckBox active={currentFlag.enabled} onClick={() => builder.imagesData.updateFlag(side, { enabled: !currentFlag.enabled })} />}
           {!currentFlag.id &&  
              <TooltipHover content={CheckBoxHelpText} width={115} offset={-80} top>
                <CheckBox disabled={true} />
              </TooltipHover>
            }
          </Markup.Screen.Logos.FlagWrapper>
        }

        {(isTablet && modalIsOpen) &&
          <ModalWrapper
              modalOnToogle={modalOnToogle}
              modalStatus={modalIsOpen}
          >
            <LogosFlag modelSide={side} onModalClose={() => changeModalState(false)}/>
          </ModalWrapper>
        }


        <Markup.Screen.Logos.NoticeMessage>
          Have your artwork in vector format? You can upload SVG files directly into the builder for the best print quality.
        </Markup.Screen.Logos.NoticeMessage>
      </Markup.Screen.Logos.SponsorWrapper>
    </>
  );
}

export default React.memo(LogosSponsor);
